import HeroSection from './components/HeroSection';
import HotSection from './components/HotSection';
import CategorySection from './components/CategorySection';
import LatestSection from './components/LatestSection';
import FAQSection from './components/FAQSection';
import SEOPageMeta from '@/components/feature/SEOPageMeta';

export default function HomePage() {
  const homepageJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '久播影院 - 最新电视剧全集免费在线观看',
    description: '久播影院电视剧全集频道，提供电视剧大全，最新电视剧全集免费在线观看不缓冲，高清国产剧、韩剧全集一网打尽。',
    url: 'https://www.jiubocinema.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '久播影院',
      url: 'https://www.jiubocinema.com/',
    },
    about: {
      '@type': 'Organization',
      name: '久播影院',
      description: '高清电视剧在线观看平台',
    },
  };

  return (
    <>
      <SEOPageMeta
        title="首页"
        description="久播影院电视剧全集频道，提供电视剧大全，最新电视剧全集免费在线观看不缓冲，高清国产剧、韩剧全集一网打尽。"
        keywords="久播影院,电视剧全集,电视剧大全,最新电视剧,免费在线观看,不缓冲,国产剧,韩剧全集,高清,在线观看"
        canonicalUrl="https://www.jiubocinema.com/"
      />
      <script type="application/ld+json">
        {JSON.stringify(homepageJsonLd)}
      </script>
      <HeroSection />
      <HotSection />
      <CategorySection />
      <LatestSection />
      <FAQSection />
    </>
  );
}